const RelationshipDropdownContainerStyles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    minWidth: 300,
    width: 300,
    fontSize: '18px !important',
  },
  inputLabel: { fontSize: 18.5 },
});

export default RelationshipDropdownContainerStyles;



// WEBPACK FOOTER //
// ./src/components/passengers/relationshipDropdown/RelationshipDropdownContainerStyles.js